import { useState } from 'react';
import { useRecoilState } from 'recoil';
import { CheckBoxField } from 'components/core';
import { builderAnswersState } from 'states';
import { LEARNER_GROUPS, toggleGroup, visibleGroups } from 'helpers/kpiBuilder/learnerGroups';
import { selectedGroups, source } from 'helpers/kpiBuilder/lookups';
import { BuilderSection } from './BuilderSection';

const INTRO =
  'Narrow down who is counted. Tick nothing to count everyone. Ticking several groups counts only learners in all of them (AND), e.g. “Pre-service students” + “Completed the course”. Groups about the same thing, like in-service and pre-service, cannot be combined, so ticking one replaces the other. Each group is a saved, shared definition, so every visualization counts it the same way.';

// Step 3: which learners are counted.
export const LearnerGroupsStep = () => {
  const [a, setA] = useRecoilState(builderAnswersState);
  const [note, setNote] = useState('');
  const visible = visibleGroups(a);
  const hidden = LEARNER_GROUPS.length - visible.length;
  const chosen = selectedGroups(a).map((g) => g.label.toLowerCase());

  const onToggle = (id: string) => {
    const next = toggleGroup(a, id);
    setNote(next.note);
    setA({ ...a, segs: next.segs, rateSeg: next.rateSeg });
  };

  return (
    <BuilderSection title="Which learners should be counted?" hint={INTRO}>
      <div className="bg-dark text-white rounded px-3 py-2 mb-2">
        <strong>Counting: </strong>
        {source(a)?.label} → {chosen.length ? `only ${chosen.join(' AND ')}` : 'everyone'}
      </div>
      {visible.map((g) => (
        <CheckBoxField key={g.id} label={g.label} subLabel={g.rule} isChecked={a.segs.includes(g.id)} clickHandler={() => onToggle(g.id)} />
      ))}
      {note && (
        <div className="alert alert-warning mt-2 mb-0" role="status">
          {note}
        </div>
      )}
      {hidden > 0 && (
        <div className="small text-secondary mt-2">
          {hidden} other {hidden === 1 ? 'group is' : 'groups are'} hidden because {hidden === 1 ? 'it does' : 'they do'} not apply to this data.
        </div>
      )}
      <div className="small text-secondary mt-1">District, block, facility and institute are not groups: they come from the dashboard&apos;s location filter.</div>
    </BuilderSection>
  );
};
